export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";